export default __webpack_public_path__ + "static/media/logo_black_no_words.4f4ecbef.png";